import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { AuthService } from "../../service/AuthService";
import { Divider } from "primereact/divider";
import { validateEmail, validatePassword, validateResetCode } from "../../helpers/auth";

export interface IResetPassword {
    email: string
    code: string
    newPassword: string
}

export const ResetPasswordPage: FC = () => {
    const navigate = useNavigate();
    const [state, setState] = useState<IResetPassword>({
        email: "",
        code: "",
        newPassword: ""
    });
    const [disableSubmitButton, setDisableSubmitButton] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);
    const [hasReset, setHasReset] = useState(false)

    useEffect(() => {
        let isValid = true;

        isValid = (!hasReset && validateEmail(state.email)) || (hasReset && validateResetCode(state.code) && validatePassword(state?.newPassword))

        setDisableSubmitButton(!isValid);
    }, [state, hasReset]);

    const resetPassword = async () => {
        setIsLoading(true);
        setDisableSubmitButton(true);
        await AuthService.resetPassword(state).then((response) => {
            if (response) {
                navigate("/");
            }
        });
        setIsLoading(false);
    };

    const requestResetPasswordCode = async () => {
        setIsLoading(true);
        setDisableSubmitButton(true);
        await AuthService.resetPassword(state)
        setIsLoading(false);
        setHasReset(true);
        setDisableSubmitButton(false);
    }

    const footer = (
        <>
            <Divider />
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>At least one special character</li>
            </ul>
        </>
    );

    return (
        <div className="relative flex flex-wrap align-items-center justify-content-center h-screen">
            <div className="vertical-align-middle border-transparent shadow-2 w-max p-5">
                <h2 className="text-center">Reset Password</h2>
                <p>Look into your email for the Reset Code we've just sent you.</p>
                {!hasReset && (
                    <div className="p-inputgroup flex-1 w-full mt-4">
                        <label className="p-inputgroup-addon" htmlFor="email">
                            <i className="pi pi-user"></i>
                        </label>
                        <InputText
                            placeholder="Email"
                            onChange={(e) => setState({ ...state, email: e.target.value as string })}
                            value={state.email}
                            id="login-email"
                            name="login-email"
                        />
                    </div>
                )}
                {hasReset && (
                  <>
                    <div className="p-inputgroup flex-1 mt-4 w-100">
                        <label className="p-inputgroup-addon" htmlFor="password">
                            <i className="pi pi-hashtag"></i>
                        </label>
                        <InputText
                            value={state.code}
                            tabIndex={1}
                            placeholder="Reset code"
                            onChange={(e) => setState({ ...state, code: e.target.value as string })}
                            id="reset-password-code"
                            name="reset-password-code"
                        />
                    </div>
                    <div className="p-inputgroup flex-1 mt-4 w-100">
                        <label className="p-inputgroup-addon" htmlFor="password">
                            <i className="pi pi-lock"></i>
                        </label>
                        <Password
                            value={state.newPassword}
                            tabIndex={1}
                            placeholder="New Password"
                            toggleMask
                            onChange={(e) => setState({ ...state, newPassword: e.target.value as string })}
                            id="login-password"
                            name="login-password"
                            footer={footer}
                        />
                    </div>
                  </>
                )}
                <div className="w-100 flex justify-content-center mt-4">
                    <Button
                        label={hasReset ? "Reset password" : "Request reset password code"}
                        className="w-full"
                        onClick={hasReset ? resetPassword : requestResetPasswordCode}
                        disabled={disableSubmitButton}
                    />
                </div>
                <div className="flex flex-column align-items-start gap-2 pt-4 text-sm">
                    <div className="flex align-items-center py-1 gap-1 h-1rem">
                        <p>Don't have an account?</p>
                        <Button
                            label="Sign Up"
                            link
                            onClick={() => navigate("/register")}
                            style={{ padding: 0 }}
                            className="text-sm"
                        />
                    </div>
                </div>
            </div>
            {isLoading && (
                <div className="absolute">
                    <ProgressSpinner />
                </div>
            )}
        </div>
    );
};
